import React from "react";
import Link from "next/link";

const CategorySelector = ({
  heading,
  categories = [],
  containerClassName = "",
  headingClassName = "",
  gridClassName = "",
  tileClassName = "",
  activeTileClassName = "",
}) => {
  // Initial state: outline style with white bg, hover: filled with primary color
  const defaultTileClass =
    "block w-full px-4 py-3 md:px-6 md:py-4 text-center text-sm md:text-base font-medium rounded-[6px] border-2 border-[#E8345E] text-[#E8345E] bg-white hover:bg-[#E8345E] hover:text-white hover:border-white hover:shadow-[0px_4px_4px_rgba(232,52,94,0.7)] transition-all duration-300 ease-in-out cursor-pointer";
  
  const defaultActiveTileClass =
    "bg-[#E8345E] text-white border-white shadow-[0px_4px_4px_rgba(232,52,94,0.7)]";

  return (
    <div className={`w-full ${containerClassName}`}>
      {/* Heading */}
      {heading && (
        <h2
          className={`text-xl md:text-2xl lg:text-[34px] font-bold text-[#333333] mb-4 md:mb-8 ${headingClassName}`}
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {heading}
        </h2>
      )}

      {/* Category Grid */}
      <div
        className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-5 ${gridClassName}`}
        style={{ fontFamily: "'Poppins', sans-serif" }}
      >
        {categories.map((category, index) => {
          const isActive = category.isActive || false;
          const finalTileClass = `${defaultTileClass} ${tileClassName} ${
            isActive ? `${defaultActiveTileClass} ${activeTileClassName}` : ""
          }`;

          // If href is provided, render as Link
          if (category.href) {
            return (
              <Link key={index} href={category.href} className={finalTileClass}>
                {category.label}
              </Link>
            );
          }

          // If onClick is provided, render as button
          if (category.onClick) {
            return (
              <button
                key={index}
                onClick={category.onClick}
                className={finalTileClass}
                type="button"
              >
                {category.label}
              </button>
            );
          }

          // Default: render as div (non-interactive)
          return (
            <div key={index} className={finalTileClass}>
              {category.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategorySelector;

